import { getEncryptedPdfPageCount } from "./getEncryptedPdfPageCount";
import { isEncryptedPdfError } from "./isEncryptedPdfError";
import { loadPdfDocument } from "./loadPdfDocument";
import { splitPageErrorHandler } from "./splitPageErrorHandler";

/**
 * Gets the total page count of a PDF file
 *
 * This function attempts to get the page count using the standard loader first,
 * then falls back to the blank password handler for encrypted PDFs.
 *
 * @param file - The PDF file to get page count from
 * @returns The total number of pages in the PDF
 * @throws {FileSplitException} If the page count cannot be determined
 */
export const getPdfPageCount = async (file: File): Promise<number> => {
  try {
    // Try standard PDF loading first
    const pdfDoc = await loadPdfDocument(file, { returnPageCount: true });
    return pdfDoc.getPageCount();
  } catch (error) {
    // Handle encrypted PDFs
    if (isEncryptedPdfError(error)) {
      return getEncryptedPdfPageCount(file);
    }

    // For all other errors, use the standard error handler
    throw splitPageErrorHandler(error);
  }
};
